<template>
  <div>
    <main-layout>
      <v-container fluid>
        <div style="background-color: #eee; border-radius: 10px">
          <v-layout wrap justify-center align-center>
            <v-flex xs12 sm4 md4 class="text-xs-center">
              <v-img
                src="/static/img/assets/ticket2/Call center-rafiki.png"
                style="width: 100%"
              ></v-img>
            </v-flex>
            <v-flex
              xs12
              sm8
              md3
              class="py-4"
              style="display: flex; justify-content: center; align-items: center"
            >
              <div class="text-xs-center black--text" style="font-size: 20px">
                <div>
                  HELLO! <strong>{{ $store.state.userid }}</strong>
                </div>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      :loading="checkinLoading || validateStatusLoading"
                      :disabled="checkinStatus"
                      class="ticket2profilebtn"
                      color="white"
                      large
                      @click="handleTicket3CheckInOut('check-in')"
                    >
                      <div>
                        <div>
                          <img
                            :style="checkinStatus ? '    filter: grayscale(100%);' : ''"
                            width="30px"
                            src="/static/img/assets/ticket2/login (2).png"
                          />
                        </div>
                        <div>Check-in</div>
                      </div>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      :loading="checkinLoading || validateStatusLoading"
                      :disabled="!checkinStatus"
                      class="ticket2profilebtn"
                      color="white"
                      large
                      @click="handleTicket3CheckInOut('check-out')"
                    >
                      <div>
                        <div>
                          <img
                            :style="!checkinStatus ? '    filter: grayscale(100%);' : ''"
                            width="30px"
                            src="/static/img/assets/ticket2/logout (1).png"
                          />
                        </div>
                        <div>Check-out</div>
                      </div>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ticket3Checkin from '@/api/ticket3/checkin'
import { handleApiError } from '@/api/util'
export default {
  name: 'CheckinView',
  data() {
    return {
      validateStatusLoading: false,
      checkinLoading: false,
      logdata: [],
      checkinStatus: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.handleCheckinStatus()
  },
  methods: {
    async handleCheckinStatus() {
      this.validateStatusLoading = true
      try {
        const response = await ticket3Checkin.getValidateCheckout()
        this.validateStatusLoading = false
        if (response.status === 200) {
          this.checkinStatus = response.data.status == false
        } else {
          this.checkinStatus = false
        }
      } catch (error) {
        this.validateStatusLoading = false
        handleApiError(error)
        this.checkinStatus = false
      }
    },
    async handleTicket3CheckInOut(actions) {
      var data = {
        admin_id: this.$store.state.userid
      }
      const result = await this.$swal.fire({
        text: `คุณต้องการ ${actions} ?`,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true
      })
      if (result.value) {
        this.checkinLoading = true
        const apiName = actions === 'check-in' ? 'postCheckin' : 'postCheckout'
        try {
          const response = await ticket3Checkin[apiName]({ data })
          this.checkinLoading = false
          if (response.status == 200) {
            this.$swal.fire({
              text: actions + ' สำเร็จ',
              type: 'success'
            })
            this.checkinStatus = actions === 'check-in' ? true : false
          } else {
            this.$swal.fire({
              text: actions + ' ไม่สำเร็จ',
              type: 'error'
            })
          }
        } catch (error) {
          handleApiError(error)
          this.checkinLoading = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
.ticket2profilebtn {
  border-radius: 15px !important;
  width: 100px !important;
  height: 94px !important;
  font-size: 14px !important;
  text-transform: none !important;

  color: grey !important;

  line-height: 21px !important;
  margin-top: 10px !important;
  //   display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket3/checkin/index.vue